// src\stores\reducers\todos.ts
// import { PROJECT } from '../../constants';
// import { IProject } from '../types'



// const projectControll = (state: IProject = {fav: false}, action: { type: string; value: any }) => {
//   switch (action.type) {
//     case PROJECT:
//       return  {
//         ...state,
//         ...action.value
//       };
//     default:
//       return state;
//   }
// };

// export default projectControll;
import { createSlice } from '@reduxjs/toolkit';
import { IProject } from '../types';
import { DEFAULT_RPC } from '@/config';
const feeTypeStorage = window.localStorage.getItem('feeType')
// const feeType = [6, 5, 7.5, 10].includes(Number(feeTypeStorage)) ? Number(feeTypeStorage) : 6
const feeType = [12, 10, 15, 20].includes(Number(feeTypeStorage)) ? Number(feeTypeStorage) : 12
const extraFloatStorage = window.localStorage.getItem('extraFloat');
const extraFloat = extraFloatStorage ? Number(extraFloatStorage) : 0
const initialState: IProject = { isMinted: false, trxs: '', isStart: false, rpc: '', feeType: feeType, transferDone: false, fees: {}, extraFloat: extraFloat };

const projectControll = createSlice({
  name: 'projectControll',
  initialState,
  reducers: {
    setProject: (state, action) => {
      state.isMinted = action.payload;
    },
    setTrxs: (state, action) => {
      state.trxs = action.payload;
    },
    setIsStarted: (state, action) => {
      state.isStart = action.payload;
    },
    setRpc: (state, action) => {
      // console.log("setRpc action.payload", action.payload);
      state.rpc = action.payload;
    },
    setFeeType: (state, action) => {
      window.localStorage.setItem('feeType',  action.payload)
      state.feeType = action.payload;
    },
    setTransferDone: (state, action) => {
      state.transferDone = action.payload;
    },
    setFees: (state, action) => {
      state.fees = action.payload;
    },
    setExtraFloat: (state, action) => {
      window.localStorage.setItem('extraFloat',  action.payload)
      state.extraFloat = action.payload;
    },
  },
});

export const { setProject } = projectControll.actions;
export default projectControll;
